import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';

export const WAKE_LIVE_KEY = ['wake-live'];

const useWakeLive = () =>
    useQuery(
        WAKE_LIVE_KEY,
        () => apiClient.get('/Wake/Live').then(r => r.data),
        {
            refetchOnMount: 'always',
            refetchOnWindowFocus: true,
        }
    );

export default useWakeLive;
